import React, { useEffect, useRef, useState } from "react";
import "./puja-campaign-download.scss";
import axios from "axios";
import ShareOptions from "./shareOptions";
import Image from "next/image";
import { FaSearchengin } from "react-icons/fa";
import { FaDownload } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
import { FaShareAlt } from "react-icons/fa";
import { saveAs } from "file-saver";

export default function PujaCampaignDownload({ userId, setIsShowDownload }) {
  const [isLoading, setIsLoading] = useState(true);
  const imgRefs = useRef([]);
  const [images, setImages] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [outputRef, setOutputRef] = useState(null);
  const [isImgLoaded, setIsImgLoaded] = useState(false);
  const [isRetry, setIsRetry] = useState(false);
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState(null);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      try {
        let res = await axios.get(
          `${process.env.SERVER_BASE_URL}/durga-puja-2025/image/get-user-images/${userId}`
        );

        // Sort Newest first
        const newestFirst = res.data?.images.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setImages(newestFirst);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  const downloadImage = async (url, name) => {
    try {
      /*  console.log(url);

      const response = await fetch(url, {
        mode: "cors",
      });

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = name || "download.jpg";
      document.body.appendChild(link); // For Firefox
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl); // Clean up */

      saveAs(url, name);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="flex-col-center PujaCampaignDownload">
      {/* {isLoading && <p>loading...</p>} */}

      <div className="closeIcon">
        <MdClose size={30} onClick={() => setIsShowDownload(false)} />
      </div>

      <div className="flex-col-center imageGridWrapper">
        {isLoading && <span className="loaderDownloadCampaign"></span>}
        {!isLoading && images.length === 0 && (
          <p
            className="flex-row-center noImgFoundCampaign"
            style={{ color: "red", width: "100%" }}
          >
            No image found.
          </p>
        )}
        <div className="flex-row-center imageGrid">
          {images.length > 0 &&
            images.map((url, index) => (
              <div className="flex-row-center singleImg" key={index}>
                {showShareOptions && (
                  <ShareOptions
                    setShowShareOptions={setShowShareOptions}
                    url={selectedUrl}
                  />
                )}
                <a
                  to={url}
                  target="_blank"
                  className="flex-row-center"
                  style={{ width: "100%", height: "100%" }}
                >
                  <Image
                    key={index}
                    src={url.outputImg}
                    ref={(el) => (imgRefs.current[index] = el)}
                    alt={`User ${index}`}
                    loading="lazy"
                    onLoad={() => setIsImgLoaded(true)}
                    width={100}
                    height={100}
                  />
                  {index === 0 && <span className="newOverlay">NEW</span>}
                </a>
                {isImgLoaded && (
                  <span
                    className="flex-row-center downloadIcon shareIcon"
                    onClick={() => {
                      setSelectedUrl(url.outputImg);
                      setShowShareOptions(true);
                    }}
                  >
                    <FaShareAlt color="black" />
                  </span>
                )}
                {isImgLoaded && (
                  <span
                    className="flex-row-center downloadIcon"
                    onClick={(e) => {
                      downloadImage(
                        url?.outputImg,
                        `snapshawt-durga-puja-blessing-${url?._id}`
                      );
                    }}
                  >
                    <FaDownload color="black" />
                  </span>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
